















































































































































import { Component, Vue } from 'vue-property-decorator'
import { Api } from '@/service/api'

@Component({
  components: {}
})
export default class GzhMenuEdit extends Vue {

  private gzhMenuId = 0
  private appId = ''
  private menuInfo: any = null
  private menuNamePlaceholder = ''

  private defaultMenu: any = null
  private individualMenus: Array<any> = []
  private currentMenu: any = null
  private currentNode: any = null

  private lastMenuKey = 0

  /* 菜单是否可编辑 */
  private editable = false

  // 树形菜单是否显示
  private menuDisplay = false

  private treeData: any[] = []

  // 当前选中的节点key
  private selectedKeys: any = []
  private expandKeys: string[] = []

  // 标签下拉
  private tagList: any = []

  private pasteModalShow = false
  private pasteContent = ''

  private labelCol: any = { span: 6 }

  private wrapperCol: any = { span: 14 }

  private async mounted () {

    await this.getMenuInfo()

    // 标签
    const res: any = await Api.getGzhTagList(this.appId)
    this.tagList = JSON.parse(res.data).tags
  }

  // 获取菜单
  private async getMenuInfo () {

    this.gzhMenuId = parseInt(this.$route.query.gzh_menu_id as string)
    this.appId = this.$route.query.app_id as string

    this.lastMenuKey = +new Date()

    const res: any = await Api.getGzhMenuInfo(this.appId, this.gzhMenuId)
    this.editable = res.data.status === 'draft'
    this.menuInfo = res.data

    if (this.menuInfo.name.startsWith('>>>>>>')) {
      this.menuNamePlaceholder = this.menuInfo.name.replace('>>>>>>', '请输入菜单备注，当前菜单复制于：')
      this.menuInfo.name = ''
    }

    this.initUI()
  }

  private initUI () {

    const content = JSON.parse(this.menuInfo.content)

    this.defaultMenu = content.menu
    if (content.conditionalmenu) {
      this.individualMenus = content.conditionalmenu
    }

    this.findMenuItemExecute(this.defaultMenu.button, '*', (items, index, item, level) => {

      const key = ++this.lastMenuKey + ''

      item.level = level
      item.keyword = item.key
      item.key = key
      item._key = key
      item.children = item.sub_button
      item.title = item.name
      item.children = item.sub_button

      item.title = item.name
    })

    for (const individualMenu of this.individualMenus) {
      this.findMenuItemExecute(individualMenu.button, '*', (items, index, item, level) => {

        const key = ++this.lastMenuKey + ''

        item.level = level
        item.keyword = item.key
        item.key = key
        item._key = key
        item.children = item.sub_button
        item.title = item.name
        item.children = item.sub_button
      })
    }

    this.currentMenu = null
    this.currentNode = null
    this.menuDisplay = false

    if (this.defaultMenu && this.individualMenus.length === 0) {
      this.checkMenu(this.defaultMenu, 'default')
    }
  }

  private checkMenu (menu: any, menuType: any) {

    this.currentMenu = menu
    this.treeData = menu.button
    this.expandKeys.splice(0, this.expandKeys.length)
    for (const menuItem of this.treeData) {
      this.expandKeys.push(menuItem.key)
    }
    this.currentNode = null
    this.menuDisplay = true
    this.lastMenuKey = +new Date()

  }

  // 当前选中的节点
  private onSelect (selectedKeys: any) {

    this.selectedKeys = selectedKeys

    const key = this.selectedKeys[0]

    this.findMenuItemExecute(this.treeData, key, (items, index, item) => {
      this.currentNode = item
    })

  }

  private findMenuItemExecute (items: any[], key: string, action: (items: any[], index: number, item: any, level?: number) => void, level = 1) {
    for (let i = 0, len = items.length; i < len; i++) {
      const item: any = items[i]
      const item_key = item.key
      if (item_key === key || key === '*') {
        if (action) {
          action(items, i, item, level)
        }
        if (key !== '*') {
          break
        }
      }

      if (item.children) {
        this.findMenuItemExecute(item.children, key, action, level + 1)
      }
    }
  }

  // 添加一级节点
  private addRootMenuItem () {
    if (this.treeData.length >= 3) {
      this.$message.error('一级菜单最多3个')
      return
    }

    const _key = ++this.lastMenuKey + ''

    this.treeData.push({
      title: '一级菜单',
      name: '一级菜单',
      level: 1,
      key: _key,
      _key: _key
    })
  }

  // 添加子菜单
  private addSubMenuItem () {

    if (this.selectedKeys && this.selectedKeys.length > 0) {
      const key = this.selectedKeys[0]

      this.findMenuItemExecute(this.treeData, key, (items, index, item) => {

        if (item.level === 2) {
          this.$message.error('最多只能有二级菜单')
          return
        }

        if (item.children && item.children.length > 6) {
          this.$message.error('二级菜单最多为7个')
          return
        }

        if (!item.children) {
          item.children = []
        }

        const _key = ++this.lastMenuKey + ''

        item.children.push({
          title: '二级菜单',
          name: '二级菜单',
          level: 2,
          type: 'view',
          key: _key,
          _key: _key
        })

        this.selectedKeys = [_key]

        this.findMenuItemExecute(this.treeData, _key, (items, index, item) => {
          this.currentNode = item
        })

      })
    }
  }

  // 删除节点
  private deleteMenuItem () {

    if (this.selectedKeys && this.selectedKeys.length > 0) {
      const key = this.selectedKeys[0]
      this.findMenuItemExecute(this.treeData, key, (items: any[], index: number, item: any) => {
        items.splice(index, 1)
      })
      this.currentNode = null
    }
  }

  private nameChanged (e: any) {
    this.currentNode.title = this.currentNode.name
  }

  // 点击保存组装数据
  private async saveMenu () {

    if (!this.menuInfo.name) {
      this.$message.error('请填写菜单备注')
      return false
    }

    const defaultMenu = JSON.parse(JSON.stringify(this.defaultMenu))
    this.findMenuItemExecute(defaultMenu.button, '*', (items, index, item) => {
      item.key = item.keyword || ''
      item.name = item.title
      item.sub_button = item.children
    })

    const individualMenus = JSON.parse(JSON.stringify(this.individualMenus))
    for (const individualMenu of individualMenus) {
      this.findMenuItemExecute(individualMenu.button, '*', (items, index, item) => {
        item.key = item.keyword || ''
        item.name = item.title
        item.sub_button = item.children
      })
    }

    const content = {
      menu: defaultMenu,
      conditionalmenu: individualMenus
    }
    console.info(content)

    const content_string = JSON.stringify(content)

    const res: any = await Api.saveGzhMenu(this.appId, this.gzhMenuId, this.menuInfo.name, content_string)

    if (res.code === 0) {
      this.$message.info('保存成功')
      return true
    }

    return false

  }

  private async publishMenu () {

    const success = await this.saveMenu()
    if (success) {
      const res: any = await Api.publishGzhMenu(this.appId, this.gzhMenuId)
      if (res.code === 0) {
        this.$message.info('发布成功')
        await this.getMenuInfo()
      }
    }

  }

  // 拖动节点到指定位置
  private onDrop (info: any) {

    const dragKey = info.dragNode.eventKey
    const dropKey = info.node.eventKey
    const gap = info.dropToGap
    const drop_position = info.dropPosition

    if (gap) { // 拖拽到目标的上方或下方缝隙处

      this.findMenuItemExecute(this.treeData, dropKey, (items, index, item) => {

        const drop_parent = items
        const brother = item
        const brother_index = index

        this.findMenuItemExecute(this.treeData, dragKey, (drag_parent, drag_index, drag) => {
          let adjust = 0
          if (drag_index < drop_position && drop_parent === drag_parent) {
            adjust = -1 // 当拖拽的菜单向下移动时，移除菜单后下方菜单的索引都会变，需要进行调整
          }
          if (brother.level === 1 && drop_parent !== drag_parent && drop_parent.length === 3) { // 拖入后会导入一级菜单大于3，则不允许拖入
            this.$message.error('二级菜单最多为3个')
            return
          }
          if (brother.level === 2 && drop_parent !== drag_parent && drop_parent.length === 7) { // 拖入后会导入二级菜单大于7，则不允许拖入
            this.$message.error('二级菜单最多为7个')
            return
          }
          if (brother.level === 1 || !drag.children || drag.children.length === 0) { // 只有拖拽到一级菜单的兄弟 或 被拖拽菜单没有子菜单时，才允许拖拽
            drag.level = brother.level
            console.info(drop_parent)
            console.info(brother_index)
            console.info(drop_position)
            drag_parent.splice(drag_index, 1)
            if (drop_position < brother_index) {
              drop_parent.splice(brother_index + adjust, 0, drag)
            } else {
              drop_parent.splice(brother_index + adjust + 1, 0, drag)
            }
          }
        })
      })

    } else { // not gap

      this.findMenuItemExecute(this.treeData, dropKey, (items, index, item) => {

        if (item.level === 1 && item.children.length < 7) { // 只有一级菜单且子菜单数量小于 7 才可以拖入

          const drop = item
          this.findMenuItemExecute(this.treeData, dragKey, (dragParent, index, drag) => {
            if (drag.children.length === 0) { // 没有子菜单时才可以拖入其它菜单
              dragParent.splice(index, 1)
              drop.children.push(drag)
              drag.level = drop.level + 1
            }
          })

        }

      })
    }
  }

  // 当前选中的行 字体加粗
  private currentRowClass (menu: any) {
    if (menu === this.currentMenu) {
      return 'current-row'
    }
  }

  // 复制一行到个性化菜单
  private copyRow (menu: any) {
    const str = JSON.stringify(menu)
    const newMenu: any = JSON.parse(str)
    newMenu.matchrule = {
      group_id: '',
      language: 'zh-CN'
    }
    this.individualMenus.push(newMenu)
  }

  // 删除一条个性化菜单
  private removeMenu (menu: any) {
    const index = this.individualMenus.indexOf(menu)
    this.individualMenus.splice(index, 1)
    this.menuDisplay = false
    this.currentNode = null
  }

  // 跳转历史菜单页面
  private async toGzhManager () {
    await this.$router.push({
      path: '/gzh_menu_manager',
      query: { app_id: this.appId }
    })
  }

  private copyMenu () {
    const content = JSON.stringify(this.menuInfo)

    const input = document.createElement('input')
    input.setAttribute('readonly', 'readonly') // 防止手机上弹出软键盘
    input.setAttribute('value', content)
    document.body.appendChild(input)
    input.select()
    const res = document.execCommand('copy')
    document.body.removeChild(input)

    this.$message.info('菜单已复制，可到其它菜单中进行粘贴')
  }

  private pasteMenu () {
    this.pasteModalShow = true
    this.pasteContent = ''
  }

  private handlePasteMenu () {
    const menuInfo = JSON.parse(this.pasteContent)
    const name = this.menuInfo.name
    this.menuInfo = menuInfo
    this.menuInfo.name = name
    this.pasteModalShow = false

    this.initUI()
  }
}
